export default __webpack_public_path__ + "static/media/soso-logo-bottom.369d71d9.png";